import api from '@pray/shared/utils/api';

export type SuppressionSummary = {
  bounces: number;
  blocks: number;
  spam_reports: number;
  invalid_emails: number;
  unsubscribes: number;
};

export type SuppressionEntry = {
  email: string;
  type: string;
  reason: string;
  created: number;
};

export type EmailHealthSuppressionsResponse = {
  summary?: SuppressionSummary;
  entries?: SuppressionEntry[];
  type?: string;
  limit?: number;
  offset?: number;
};

export type GetEmailHealthSuppressionsParams = {
  type?: string;
  limit?: number;
  offset?: number;
};

export async function getEmailHealthSuppressions({
  type,
  limit,
  offset,
}: GetEmailHealthSuppressionsParams = {}): Promise<EmailHealthSuppressionsResponse> {
  const params: Record<string, string | number> = {};

  if (type) params.type = type;
  if (limit !== undefined) params.limit = limit;
  if (offset !== undefined) params.offset = offset;

  const url = '/web/studio/system-check/email-health/suppressions';
  const response = await api.executeGetRequest<{ data: EmailHealthSuppressionsResponse }>(url, params);

  return response.data.data;
}
